import { useApplyEdition } from '@/pages/Apply/components/use-apply-edition';
import type { ApplyApplicationsShow } from '@/types';
import { GithubSignInButton } from '../components/GithubSignInButton';

// app/(public)/${eventSlug}/apply/page.tsx — the landing a signed-out leader sees. Every signed-in
// case is a redirect the controller answers.
export default function Show({ eventMissing }: ApplyApplicationsShow) {
  const { eventSlug, eventCity } = useApplyEdition();
  if (eventMissing) {
    return (
      <>
        <div className="mx-auto max-w-md p-8 text-center">
          <h1 className="font-bold text-2xl uppercase tracking-wide">
            Evento no encontrado
          </h1>
          <p className="mt-4 text-muted-foreground">
            Contacta a los organizadores.
          </p>
        </div>
      </>
    );
  }

  return (
    <>
      <div className="mx-auto max-w-xl space-y-8 px-4 py-16">
        <header className="space-y-3 text-center">
          <h1 className="font-bold text-3xl uppercase tracking-wide sm:text-4xl">
            Postulación a Platanus Hack{' '}
            <span className="font-logo tracking-tight">26</span>
            <span className="font-normal font-title tracking-normal">
              : {eventCity}
            </span>
          </h1>
          <p className="text-muted-foreground">
            Eres el líder del equipo. Empieza iniciando sesión con GitHub —
            después podrás invitar al resto de tu equipo.
          </p>
        </header>

        <div className="border-2 border-primary bg-background/80 p-6 sm:p-8">
          <div className="space-y-4">
            <p className="text-sm">
              Para empezar, conecta tu cuenta de GitHub.
            </p>
            {/* Back through /${eventSlug}/apply so the smart routing handles the
                already-submitted / draft / fresh-user cases consistently. */}
            <GithubSignInButton
              callbackURL={`/${eventSlug}/apply`}
              errorCallbackURL={`/${eventSlug}/apply?error=github_signin_failed`}
              label="Iniciar con GitHub"
            />
          </div>
        </div>
      </div>
    </>
  );
}
